// src/components/LiveVehicleMarker.jsx
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";

// Import vehicle icons
import carIcon from "../assets/car.png";
import vanIcon from "../assets/van.png";
import busIcon from "../assets/bus.png";
import lorryIcon from "../assets/lorry.png";
import suvIcon from "../assets/suv.png";
import cabIcon from "../assets/cab.png";
import forkliftIcon from "../assets/fork lift.png";
import dockyardIcon from "../assets/dockyard.png";
import cherryIcon from "../assets/cherry.png";
import craneIcon from "../assets/crane.jpg";

// Function to get vehicle icon based on type (supports both codes and full names)
const getVehicleIcon = (vehicleType) => {
  const type = vehicleType?.toUpperCase()?.trim() || "C";
  let iconUrl = carIcon;
  
  // Match by code first, then by name
  if (type === "V" || type.includes("VAN")) iconUrl = vanIcon;
  else if (type === "B" || type.includes("BUS")) iconUrl = busIcon;
  else if (type === "L" || type.includes("LORRY") || type.includes("TRUCK")) iconUrl = lorryIcon;
  else if (type === "S" || type.includes("SUV")) iconUrl = suvIcon;
  else if (type === "CA" || type.includes("CAB") || type.includes("TAXI")) iconUrl = cabIcon;
  else if (type === "F" || type.includes("FORKLIFT") || type.includes("FORK")) iconUrl = forkliftIcon;
  else if (type.includes("DOCKYARD")) iconUrl = dockyardIcon;
  else if (type === "CH" || type.includes("CHERRY")) iconUrl = cherryIcon;
  else if (type === "CR" || type.includes("CRANE")) iconUrl = craneIcon;
  else if (type === "C" || type.includes("CAR")) iconUrl = carIcon;
  
  return new L.Icon({
    iconUrl: iconUrl,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });
};

export default function LiveVehicleMarker({ position, vehicleType }) {
  if (!position) return null;

  return (
    <Marker position={[position.lat, position.lng]} icon={getVehicleIcon(vehicleType)}>
      <Popup>
        <div className="text-center">
          <strong>Live Location</strong>
          <br />
          {vehicleType && <><strong>Vehicle:</strong> {vehicleType}<br /></>}
          {position.lat.toFixed(6)}, {position.lng.toFixed(6)}
        </div>
      </Popup>
    </Marker>
  );
}